import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#C12B2D';
const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		borderBottomColor: '#C12B2D',
		backgroundColor: '#C12B2D',
		borderBottomWidth: 1,
		alignItems: 'center',
		height: 24,
		textAlign: 'center',
		fontStyle: 'bold',
		flexGrow: 1,
	},
	name: {
		width: '50%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		color: 'white',
	},
	description: {
		width: '30%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		color: 'white',
	},
	// qty: {
	//   width: "20%",
	//   borderRightColor: borderColor,
	//   borderRightWidth: 1,
	// },
	rate: {
		width: '20%',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		color: 'white',
	},
	//   amount: {
	//     width: "15%",
	//   },
});

const InvoiceTableHeader = () => {
	const { t } = useTranslation();
	return (
		<View style={styles.container}>
			<Text style={styles.name}>{t('material')}</Text>
			<Text style={styles.description}>{t('quantity')}</Text>
			<Text style={styles.rate}>{t('volume')}</Text>
		</View>
	);
};

export default InvoiceTableHeader;
